import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { NavMenuComponent } from './nav-menu/nav-menu.component';
import { OrgQuarterSelectorComponent } from './org-quarter-selector/org-quarter-selector.component';
import { SharedModule } from '../shared/shared.module';
import { RouterModule } from '@angular/router';
import { MatDialogModule } from '@angular/material/dialog';
import { AuthAdminGuard } from './guards/auth-admin.guard';
import { FormEditingGuard } from './guards/form-editing.guard';
import { ActiveUserGuard } from './guards/active-user.guard';

@NgModule({
    imports: [SharedModule, RouterModule, MatDialogModule, CommonModule],
    declarations: [NavMenuComponent, OrgQuarterSelectorComponent],
    providers: [AuthAdminGuard, FormEditingGuard, ActiveUserGuard],
    exports: [NavMenuComponent, OrgQuarterSelectorComponent]
})

export class CoreModule { }
